import type { Xapi } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

export function queryXapi(clientId: string) {
  return query<Xapi>(
    DataTypeSystem.Xapi,
    {
      'filter[client.id]': clientId,
    },
    jsonApiOptions
  );
}
